/**
 * When GraphQL mutations return Transaction.matchs without per-match `entries`,
 * preserve `entries` from the previous Redux editData by docId (defensive merge).
 *
 * @param {Array<object>|undefined|null} prevMatchs - editData.matchs before the mutation
 * @param {Array<object>|undefined|null} nextMatchs - matchs from mutation response
 * @returns {Array<object>|undefined|null}
 */
export function mergeTransactionMatchsPreserveEntries(prevMatchs, nextMatchs) {
  if (!Array.isArray(nextMatchs)) return nextMatchs;
  const prevByDoc = new Map();
  for (const m of prevMatchs || []) {
    const key = m?.docId != null ? String(m.docId) : '';
    if (key) prevByDoc.set(key, m);
  }
  return nextMatchs.map((nm) => {
    const key = nm?.docId != null ? String(nm.docId) : '';
    const old = key ? prevByDoc.get(key) : undefined;
    if (!old) return nm;
    return {
      ...old,
      ...nm,
      entries: nm.entries !== undefined && nm.entries !== null ? nm.entries : old.entries,
    };
  });
}
